<form *ngIf='form as form' [formGroup]='form' (ngSubmit)='submit()' autocomplete='off' novalidate>
  <fieldset>
    <legend>
      Dane podstawowe
    </legend>
    <div class="row">
      <div class='col-md-8'>
        <div class='form-group' *ngIf='"typeOfFailure" as controlName'>
          <label [for]='controlName'>
            Rodzaj awarii *
          </label>
          <input
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu rodzaj awarii'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
  </fieldset>
  <br>
  <fieldset>
    <legend>
      Etapy
    </legend>
    <app-tab-view
      [simple]='false'
      (onAddNew)='form.addStage()'
      addBtnTitle='Dodaj kolejny etap'
      [showAddButton]='true'
      [centered]='true'
      formArrayName='stages'>
      <ng-container *ngFor='let stageForm of form.getStageForms(); let i = index;'>
        <app-tab-panel
          (onClose)='form.removeStage(i)'
          [closeBtnDisabled]='i === 0'
          [showCloseBtn]='true'
          [name]='"Etap nr " + (i + 1)' [selected]='i === (form.stages.controls.length - 1)'>
          <app-notification-of-emergency-stage-form
            [label]='"Etap nr " + (i + 1)'
            [canRemoveStage]='i !== 0'
            [form]='stageForm'>
          </app-notification-of-emergency-stage-form>
        </app-tab-panel>
      </ng-container>
    </app-tab-view>
  </fieldset>
  <div class='form-actions'>
    @if (showCancel) {
      <button type='button' class='btn btn-secondary' (click)='cancel()'>
        <i class='fa fa-ban'></i>Anuluj
      </button>
    }
    <button type='submit' class='btn btn-secondary' *ngIf='edit'>
      <i class='fa fa-save'></i>Zaktualizuj dane
    </button>
    <button type='submit' class='btn btn-secondary' *ngIf='!edit'>
      <i class='fa fa-plus'></i>Dołącz do wniosku
    </button>
  </div>
</form>
